import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export type HoverCardContentProps = HoverCardPrimitive.HoverCardContentProps;

const HoverCardContent = forwardRef<HTMLDivElement, HoverCardContentProps>(
  (
    {
      className,
      side = "top",
      align = "start",
      sideOffset = 6,
      collisionPadding = 8,
      ...props
    },
    ref,
  ) => (
    <HoverCardPrimitive.Portal>
      <HoverCardPrimitive.Content
        align={align}
        className={twMerge(
          "z-50 rounded-lg border border-gray-100 bg-white p-3 shadow-md outline-none",
          className,
        )}
        collisionPadding={collisionPadding}
        ref={ref}
        side={side}
        sideOffset={sideOffset}
        {...props}
      />
    </HoverCardPrimitive.Portal>
  ),
);

HoverCardContent.displayName = "HoverCardContent";

export default HoverCardContent;
